import type { FC } from "react";

import { Text } from "shared/uikit";
import { TextStylesEnum, TextVariantsEnum } from "shared/uikit/types";
import { formatMoney } from "utils/formatMoney";

import type { PaymentRequestAmountSummary } from "./amountSummary";

interface CollectedAmountCellProps {
	summaries: PaymentRequestAmountSummary[];
}

const CollectedAmountCell: FC<CollectedAmountCellProps> = ({ summaries }) => (
	<div className="flex flex-col gap-1">
		{summaries.map(summary => (
			<div key={summary.currency} className="flex items-baseline gap-2">
				{summaries.length > 1 && (
					<Text variants={TextVariantsEnum.Caption3} style={TextStylesEnum.Hint} className="min-w-[34px] uppercase">
						{summary.currency}
					</Text>
				)}
				<Text variants={TextVariantsEnum.BodyMedium} className="whitespace-nowrap">
					{formatMoney(summary.collectedAmount, { currency: summary.currency })} /{" "}
					<span className="text-hint">{formatMoney(summary.totalAmount, { currency: summary.currency })}</span>
				</Text>
			</div>
		))}
	</div>
);

export default CollectedAmountCell;
